import React, { Suspense } from "react";
import { AppContainer } from "react-hot-loader";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import Routes from "./Routes";
import DomainNameUtils from "~/utils/DomainNameUtils";
import i18n from "~/components/i18n";
import ContentLoaderSimple from "~/components/element/ContentLoaderSimple";

const root = document.getElementById("root");

// add "tourbuzz" class name to the root container to tell if we are or not in a custom domain.
if (DomainNameUtils.isCustomDomain()) {
  const classNames = root.className.split(" ");
  classNames.push("custom-domain");
  root.className = classNames.join(" ");
}

export default function doRender(routes) {
  const router = (
    <Suspense fallback={<ContentLoaderSimple />}>
      <I18nextProvider i18n={i18n}>
        <AppContainer>
          <BrowserRouter basename="/panel/client">{routes}</BrowserRouter>
        </AppContainer>
      </I18nextProvider>
    </Suspense>
  );

  render(router, root);
}

i18n.init(err => {
  if (err) {
    window.alert("Something went wrong. Please reload this page.");
    return;
  }
  doRender(Routes);
});

if (module.hot) {
  module.hot.accept("./Routes", () => {
    // doRender(Routes);
    window.reloadApp(); // temporary fix to mobx issue
  });
}
